
import { Flex, Text, Divider } from "@chakra-ui/react";
import Logo from "../../assets/svg/logo.svg";
import insta from "../../assets/svg/insta.svg";
import twitter from "../../assets/svg/twitter.svg";
import facebook from "../../assets/svg/facebook.svg";


function Footer() {


  return (
    <>
      <Flex
        color="rgba(130, 135, 151, 1)"
        fontFamily="Montserrat"
        fontSize="14px"
        fontWeight="500"
        lineHeight="22.4px"
        direction="column"
        padding={'10px'}
        justifyContent="space-evenly"
        bg="linear-gradient(89.88deg, rgba(43, 0, 236, 0.1) 0.11%, rgba(146, 68, 244, 0.1) 100.7%)"
        h="25rem"
      >
        <Flex justifyContent="space-around" align="center" direction={{ base: 'column', md: 'row' }}>
          <Flex gap=".5rem" direction="column" >
            <img src={Logo} alt="SMS Flash logo" width="180px" height="50px" />
            <Text>Our marketing company is a results-driven agency</Text>
            <Text>dedicated to helping businesses achieve their</Text>
            <Text mb="1rem">growth objectives.</Text>
            <Flex align="center" gap="1rem">
              <img src={facebook} alt="Facebook" width="8px" height="10px" />
              <img src={twitter} alt="Twitter" width="20px" height="20px" />
              <img src={insta} alt="Instagram" width="20px" height="20px" />
            </Flex>
          </Flex>
          <Flex gap="2rem" direction="column" mt={{ base: '1rem', md: '0px' }} >
            <Flex align="center" gap="5rem" >
              <Text>Home</Text>

              <Text>About Us</Text>
              <Text>Features</Text>
            </Flex>
            <Flex align="center" gap="5rem">
            </Flex>
          </Flex>
        </Flex>

        <Divider borderWidth="3px" color="rgba(123, 126, 150, 1)" />
        <Flex align="center" justifyContent="space-evenly">
          <Text ml="0.5rem">© Copyright 2023 smsflash</Text>
          <Text mr="0.5rem">Made with love by smsflash</Text>
        </Flex>
      </Flex>
    </>
  );
}

export default Footer;
